import React from 'react';
import { IconProps } from '.';

const SvgSetting = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M8.767 2.319A1.238 1.238 0 0 1 10 1.25h4c.606 0 1.15.439 1.233 1.069l.32 2.234c.391.186.761.403 1.113.646l2.116-.85.012-.004c.524-.19 1.199-.019 1.519.556l2.001 3.462.005.008c.284.521.18 1.198-.314 1.588l-.003.002-1.782 1.393c.018.207.03.421.03.646 0 .225-.012.44-.03.646l1.785 1.395c.494.39.598 1.067.314 1.588l-.005.008-2.001 3.462a1.238 1.238 0 0 1-1.536.55l-.007-.003-2.107-.847a8.405 8.405 0 0 1-1.11.647l-.32 2.235A1.238 1.238 0 0 1 14 22.75h-4c-.606 0-1.15-.439-1.233-1.069l-.32-2.234a8.043 8.043 0 0 1-1.113-.646l-2.116.85-.012.004c-.524.19-1.199.019-1.519-.556l-2-3.462-.005-.008a1.254 1.254 0 0 1 .313-1.588l.003-.002 1.782-1.393A7.468 7.468 0 0 1 3.75 12c0-.22.012-.436.03-.646L1.998 9.961l-.003-.002a1.243 1.243 0 0 1-.303-1.607l1.995-3.451a1.238 1.238 0 0 1 1.536-.55l.007.003 2.107.847a8.42 8.42 0 0 1 1.11-.647l.32-2.235Zm1.453.431-.408 2.851-.398.163a6.936 6.936 0 0 0-1.524.886l-.338.253-2.67-1.072-1.784 3.086 2.269 1.774-.053.422c-.038.305-.064.6-.064.887 0 .286.026.582.064.887l.053.422-2.269 1.774 1.784 3.086 2.676-1.075.34.261c.47.363.973.658 1.516.881l.398.163.408 2.851h3.56l.409-2.851.397-.163a6.934 6.934 0 0 0 1.524-.886l.338-.253 2.67 1.072 1.784-3.086-2.269-1.774.053-.422c.038-.305.064-.591.064-.887 0-.296-.026-.582-.064-.887l-.053-.422 2.269-1.774-1.784-3.086-2.676 1.075-.34-.262a6.558 6.558 0 0 0-1.516-.88l-.398-.163-.408-2.851h-3.56ZM12 9.25A2.754 2.754 0 0 0 9.25 12 2.754 2.754 0 0 0 12 14.75 2.754 2.754 0 0 0 14.75 12 2.754 2.754 0 0 0 12 9.25ZM7.75 12A4.254 4.254 0 0 1 12 7.75 4.254 4.254 0 0 1 16.25 12 4.254 4.254 0 0 1 12 16.25 4.254 4.254 0 0 1 7.75 12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgSetting;
